<template>
  <div class="headerView">
    <div class="headerView_box">
      <div class="headerView_wrap">
        <div class="header_left" @click="toHome">
          <img class="img_item logo" :src="$imgUrl + pageConfig.logo" alt="" />
          <span class="name">{{pageConfig.schoolName}}继续教育综合平台</span>
        </div>
        <div class="header_middle">
          <a
            class="router_item"
            :class="{ 'router-link-active': item.url && $route.path.startsWith(item.url) }"
            v-for="(item, key, index) in filteredRouterConfig"
            :key="item + key + index"
            :href="item.url ? item.url : 'javascript:;'"
            @click.prevent="handleRouterClick(key)"
            >{{ item.text }}</a
          >
        </div>
        <div class="header_right_box">
          <div class="right_item right_1" :class="{right_active: $route.query.key === 'myMsg'}" @click="$router.push({name: 'myMsg'})">
            <img src="../../assets/images/my_msg.png" alt="" />
            <span>收件箱</span>
            <span class="drow_num" v-if="msgNum">{{msgNum}}</span>
          </div>
          <div class="right_item right_1" :class="{right_active: $route.query.key === 'course'}" @click="toNoticePage('course')">
            <img src="../../assets/images/notice.png" alt="" />
            <span>通知</span>
            <span class="un_read" v-show="+unReadNum"></span>
          </div>
          <div class="right_item right_2" :class="{right_active: $route.query.key === 'system'}"  @click="toNoticePage('system')">
            <img src="../../assets/images/msg.png" alt="" />
            <span>消息</span>
          </div>
          <!-- 已登录 -->
          <div
            class="header_logined right_3"
            @mouseenter="showDropBox('up')"
            @mouseleave="showDropBox('down')"
          >
            <img
              class="login_ava"
              src="../../assets/images/avatar_ico.png"
              alt=""
            />
            <span class="user_name" v-text="userName"></span>
            <i
              class="el-icon-arrow-down select_arrow"
              :class="{
                select_arrow_1: showDrop === 'up',
                select_arrow_2: showDrop === 'down',
              }"
            ></i>
            <ul class="select_drow">
              <li
                class="drow_item"
                :class="{ active_drop: currentPathName === key, checked_item: key === 'checkIn' && haveCheckIn }"
                v-for="(item, key, index) in filteredDropConfig"
                :key="item + key + index"
                @click="handlerPage(key)"
              >
                <span class="drow_text" v-text="item.text"></span>
              </li>
              <li class="login_out_btn" @click="toLoginOut">退出</li>
            </ul>
          </div>
          <!-- <div class="right_item right_4" @click="toLoginOut">
            <img src="../../assets/images/loginout.png" alt="" />
            <span>退出</span>
          </div> -->
        </div>

        <div class="switch_box">
           <div
          class="tab_switch"
          v-if="pagePath !== 'loginout' && authList.length >= 2"
        >
          <div
            class="switch_item"
            :class="{ active: currentAuth === 'teach' }"
            @click="switchAuth('teach')"
            v-if="authList.includes('adultTeach') || authList.includes('studyOnline')"
          >
            成教
          </div>
          <div
            class="switch_item"
            :class="{ active: currentAuth === 'train' }"
            @click="switchAuth('train')"
            v-if="authList.includes('train')"
          >
            培训
          </div>
          <div
            class="switch_item"
            :class="{ active: currentAuth === 'selfExam' }"
            @click="switchAuth('selfExam')"
            v-if="authList.includes('selfExam')"
          >
            自考
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="headerView_search" v-if="showSearch">
      <SearchView></SearchView>
    </div>
    <!-- <LoginoutBox v-model="showLoginBox"></LoginoutBox> -->

    <!-- 微信绑定二维码弹框 -->
    <el-dialog
      :visible.sync="showQrCodeDialog"
      width="420px"
      center
      :close-on-click-modal="false"
      custom-class="wechat-qrcode-dialog"
    >
      <div class="qrcode-dialog-content">
        <div class="wechat-header">
          <i class="el-icon-chat-dot-round wechat-icon"></i>
          <span class="wechat-title">微信扫码绑定</span>
        </div>
        <div class="qrcode-tip">请使用微信扫一扫</div>
        <div id="qrcode" ref="qrcode" class="qrcode-container"></div>
        <div class="qrcode-footer">扫描上方二维码完成绑定</div>
        <div class="btn-group">
          <div class="refresh-btn" @click="refreshQrCode">
            <i class="el-icon-refresh"></i>
            刷新二维码
          </div>
          <div class="close-btn" @click="showQrCodeDialog = false">关闭</div>
        </div>
      </div>
    </el-dialog>

    <!-- 申请毕业确认弹框 -->
    <el-dialog
      :visible.sync="showApplyDialog"
      width="500px"
      center
      :close-on-click-modal="false"
      append-to-body="true"
      custom-class="apply-graduation-dialog"
      title="毕业信息确认"
    >
      <div class="apply-dialog-content">
        <el-form label-width="100px" class="graduation-form">
          <el-form-item label="姓名：">
            <span class="form-value">{{ studentInfo.studentName || '-' }}</span>
          </el-form-item>
          <el-form-item label="性别：">
            <span class="form-value">{{ studentInfo.sexName || '-' }}</span>
          </el-form-item>
          <el-form-item label="身份证号：">
            <span class="form-value">{{ studentInfo.certNum || '-' }}</span>
          </el-form-item>
          <el-form-item label="出生日期：">
            <span class="form-value">{{ studentInfo.birthDate || '-' }}</span>
          </el-form-item>
          <el-form-item label="专业：">
            <span class="form-value">{{ studentInfo.majorName || '-' }}</span>
          </el-form-item>
        </el-form>
        <div class="m_tip">注意：确认学历信息无误，申请毕业。</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showApplyDialog = false">取消</el-button>
        <el-button v-if="studentInfo.hasApplyGraduation === 0" type="primary" @click="applyGraduation">申请</el-button>
        <el-button v-if="studentInfo.hasApplyGraduation === 1" type="danger" @click="revokeGraduation">撤销</el-button>
      </div>
    </el-dialog>

    <!-- 毕业生信息核对弹框 -->
    <el-dialog
      :visible.sync="showVerifyRollDialog"
      width="480px"
      center
      :close-on-click-modal="false"
      append-to-body="true"
      custom-class="verify-roll-dialog"
      title="毕业生信息核对"
    >
      <div class="verify-roll-content">
        <ul class="info-list">
          <li class="info-item">
            <span class="info-label">姓名</span>
            <span class="info-value">{{ studentRollData.name || studentRollData.studentName || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">性别</span>
            <span class="info-value">{{ studentRollData.sexName || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">学号</span>
            <span class="info-value">{{ studentRollData.studentNo || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">身份证号</span>
            <span class="info-value">{{ studentRollData.certNum || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">民族</span>
            <span class="info-value">{{ studentRollData.nationName || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">出生日期</span>
            <span class="info-value">{{ studentRollData.birthDate || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">专业</span>
            <span class="info-value">{{ studentRollData.majorName || '-' }}</span>
          </li>
          <li class="info-item">
            <span class="info-label">层次</span>
            <span class="info-value">{{ studentRollData.educationLevelName || '-' }}</span>
          </li>
        </ul>
        <div class="verify-tip">* 信息有误请联系学生科 0776-2849296</div>
      </div>
      <div slot="footer" class="verify-roll-footer">
        <el-button @click="showVerifyRollDialog = false">关闭</el-button>
        <el-button type="primary" @click="confirmVerifyRoll">确认信息无误</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import to from "await-to-js";
import api from "@/fetch/api";
import SearchView from "./SearchView.vue";
import { setCookies, getCookies } from "@/utils/utils";
import { setQuery, removeCookies } from "@/utils/utils";
import QRCode from "qrcodejs2";
// import LoginoutBox from "@/components/pages/LoginoutBox"
export default {
  name: "headerView",
  data() {
    return {
      msgNum: 0,
      showLoginBox: false,
      sysName: "继续教育综合平台",
      unReadNum: getCookies("unRead") || 0,
      onOff: getCookies("onOff") || false,
      showDrop: "",
      isBindWx: false,
      showQrCodeDialog: false,
      showApplyDialog: false,
      showVerifyRollDialog: false,
      graduateRecordInfo: {},
      haveCheckIn: false,
      qrCodeInstance: null,
      checkStatusTimer: null,
      studentMenuList: JSON.parse(localStorage.getItem('studentMenu') || 'null'),
      menuCodeMap: {
        forum: 'forum_code',
        course: 'course_code',
        moreLive: 'moreLive_code',
        homeWork: 'homeWork_code',
        aiChat: 'aiChat_code',
        myCourseForm: 'myCourseForm_code',
        myGrade: 'myGrade_code',
        myStudy: 'myStudy_code',
        onlineExamination: 'onlineExamination_code',
        rollCard: 'rollCard_code',
        teachEvaluate: 'teachEvaluate_code',
        applyFinish: 'finishStudy_code',
        graduateRegister: 'graduateRegister_code',
        checkIn: 'checkIn_code',
        myAsk: 'myAsk_code',
        myPlanCourse: 'myPlanCourse_code',
        myAttendance: 'myAttendance_code',
        feeDetail: 'feeDetail_code',
        myForum: 'myForum_code',
        thesis: 'thesis_code',
        degree: 'degree_code',
        rollRegister: 'rollRegister_code',
        slowGraduation: 'slowGraduation_code',
        rollChange: 'rollChange_code',
        bindWx: 'bindWeChat_code',
        downLoadData: 'downLoadData_code',
        question: 'question_code',
        ossRedirect: 'ossRedirect_code',
        myAppeal: 'myAppeal_code',
        myFeedback: 'myFeedback_code',
      },
      routerConfig: {
        home: {
          text: "首页",
          url: "/home",
        },
        course: {
          text: "视频课程",
          url: "/course",
        },
        moreLive: {
          text: "直播课程",
          url: "/moreLive",
        },
        homeWork: {
          text: "作业",
          url: "/homeWork",
        },
        aiChat: {
          text: "AI助手",
          url: "/aiChat",
        },
        ossRedirect: {
          text: "论文系统",
          url: "",
        },
        // notice: {
        //   text: "消息公告",
        //   url: "/notice",
        // },
      },
      dropConfig: {
        account: {
          text: "账号管理",
        },
        myRoll: {
          text: "我的学籍",
        },
        myCourseForm: {
          text: "我的课表",
        },
        myGrade: {
          text: "在线成绩",
        },
        myStudy: {
          text: "学习记录",
        },
        onlineExamination: {
          text: "在线考试",
        },
        rollCard: {
          text: "学籍卡",
        },
        teachEvaluate: {
          text: "教学评价",
        },
        applyFinish: {
          text: "申请毕业",
        },
        graduateRegister: {
          text: "毕业档案",
        },
        checkIn: {
          text: "报到",
        },
        signaturePreview: {
          text: "电子签名",
        },
        // buy: {
        //   text: "教材订购",
        // },
        myAsk: {
          text: "我的提问",
        },
        myPlanCourse: {
          text: "教学计划课程",
        },
        myAttendance: {
          text: "我的考勤",
        },
        feeDetail: {
          text: "缴费记录",
        },
        myForum: {
          text: "我的论坛",
        },
        thesis: {
          text: "我的论文",
        },
        degree:{
          text: "学位外语"
        },
        rollRegister:{
          text: "暂缓注册"
        },
        slowGraduation:{
          text: "暂缓毕业"
        },
        rollChange:{
          text: "学籍异动"
        },
        myAppeal: {
          text: "我的申诉",
        },
        bindWx: {
          text: "绑定微信",
        },
        downLoadData: {
          text: "资料下载",
        },
        myFeedback: {
          text: "意见反馈",
        },
        question: {
          text: "常见问题",
        },
        forum: {
          text: "论坛",
        },
        contactUs: {
          text: "联系我们",
        },
      },
      studentInfo: {},
      codeState: "",
    };
  },
  created() {
     if(getCookies("token")){
      this.courseNoticeUnRead();
      this.myMsgUnReadNum();
      this.getUserInfo();
      this.getStudentMenu();
    }
    setCookies("onOff", true);
  },
  mounted() {
    window.GETNOREADNUM = this.myMsgUnReadNum;
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopCheckStatus();
  },
  methods: {
    async getStudentMenu(){
      const [err, res] = await to(api.getMenu());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        let menuData = res.data || [];
        localStorage.setItem('studentMenu', JSON.stringify(menuData));
        this.studentMenuList = menuData;
      }
    },
    getUserInfo(){
      let _obj = JSON.parse(getCookies("userInfo"));
      this.isBindWx = _obj.haveBind == 1 ? true : false;
      this.haveCheckIn = _obj.haveCheckIn == 1 ? true : false;
      if(this.isBindWx){
        this.dropConfig.bindWx.text = "解绑微信";
      }else{
        this.dropConfig.bindWx.text = "绑定微信";
      }
      if(this.haveCheckIn){
        this.dropConfig.checkIn.text = "已报到";
      }else{
        this.dropConfig.checkIn.text = "报到";
      }
    },
    switchAuth(type){
      this.$store.commit("setAuth", type);
       setCookies("auth",type);
       sessionStorage.setItem('needRedirect', 'true');
        // 4. 刷新页面
        window.location.reload();
    },
    async myMsgUnReadNum(){
       const [err, res] = await to(api.myMsgUnReadNum());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.msgNum = res.data
      }else{
        console.log()
        // this.$toast.success('这是一个全局 Toast');
      }
    },
    async courseNoticeUnRead(item){
      const [err, result] = await to(api.courseNoticeUnRead());
      if (err) return Promise.reject(err);
      if (result.code === 200) {
         this.unReadNum = result.data.unreadNum;
         setCookies("unRead", result.data.unreadNum)
      } else {
      }
    },
    setUnRead(num){
      this.unReadNum = num;
      setCookies("unRead", num)
    },
    toNoticePage(e){
      if(e === this.$route.query.key){
        return;
      };
      this.$router.push({name: "notice", query: {key: e}})
    },
    // 显示下拉
    showDropBox(e) {
      this.showDrop = e;
    },
    // 导航栏点击
    handleRouterClick(key) {
      if (key === "ossRedirect") {
        this.handleOssRedirect();
        return;
      }
      this.$router.push({ path: this.routerConfig[key].url });
    },
    // 去登录页面
    toLoginOut(e) {
       this.$confirm('此操作将退出当前登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.loginOutFn();
        })

    },

    // 下拉点击
    handlerPage(e) {
      if(e === "buy"){
        return this.$message.warning("此功能暂未开放")
      };
      if(e === "bindWx"){
        if(this.isBindWx){
          this.$confirm('确认是否解绑微信？解绑后将无法接收微信公众号推送的信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unBind();
        })
        }else{
          this.getBindQrCode();
        }

        return;
      };
      if(e === "applyFinish"){
        this.showApplyFinish();
        return;
      }
      if(e === "ossRedirect"){
        this.handleOssRedirect();
        return;
      }
      if(e === "checkIn"){
        if(this.haveCheckIn){
          return;
        }
        this.$router.push({ name: e });
        return;
      }
      if(e === "graduateRegister"){
        this.checkGraduateVerifyRoll();
        return;
      }

      this.$router.push({ name: e });
    },
    async checkGraduateVerifyRoll(){
      const [err, res] = await to(api.getGraduateRecordInfo());
      if (err) return Promise.reject(err);
      if (res.code !== 200) return;
      const data = res.data || {};
      this.graduateRecordInfo = data;
      if (data.haveVerifyRoll === 1) {
        this.$router.push({ name: "graduateRegister" });
        return;
      }
      if (!this.$store.state.studentRoll || !this.$store.state.studentRoll.studentRollId) {
        await this.$store.dispatch("getMyRoll");
      }
      this.showVerifyRollDialog = true;
    },
    confirmVerifyRoll(){
      this.$confirm('请确认毕业生信息无误后再提交，提交后将无法修改', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'graduation-confirm-box',
        center: true
      }).then(async () => {
        const rollId = this.graduateRecordInfo.rollId
          || (this.$store.state.studentRoll && this.$store.state.studentRoll.studentRollId);
        const [err, res] = await to(api.verifyGraduateInfo({ rollId }));
        if (err) return Promise.reject(err);
        if (res.code === 200) {
          this.$message.success("信息核对成功");
          this.showVerifyRollDialog = false;
          this.$router.push({ name: "graduateRegister" });
        }
      }).catch(() => {});
    },
   async handleOssRedirect(){
      const [err, res] = await to(api.ssoRedirect());
      if (err) return Promise.reject(err);
      if (res.code === 200 && res.msg) {
        window.open(res.msg, '_blank');
      }
    },
   async showApplyFinish(){
      const [err, res] = await to(api.getRollGraduationVO());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
       this.studentInfo = res.data;
       this.showApplyDialog = true;
      }
    },
    applyGraduation(){
      this.$confirm('确认学历信息无误，申请毕业', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'graduation-confirm-box',
        center: true
      }).then(async () => {
        const [err, res] = await to(api.applyGraduation());
        if (err) {
          return Promise.reject(err);
        }
        if (res.code === 200) {
          this.showApplyDialog = false;
          this.$message.success("申请毕业成功");
        }
      }).catch(() => {
        // 用户取消操作
      });
    },
    revokeGraduation(){
      this.$confirm('确认要撤销毕业申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'graduation-confirm-box',
        center: true
      }).then(async () => {
        const [err, res] = await to(api.revokeGraduation());
        if (err) {
          return Promise.reject(err);
        }
        if (res.code === 200) {
          this.showApplyDialog = false;
          this.$message.success("撤销毕业申请成功");
        }
      }).catch(() => {
        // 用户取消操作
      });
    },
    async getBindQrCode(){
       const [err, res] = await to(api.getBindQrCode());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.codeState = res.data.state;
        this.showQrCodeDialog = true;

        // 等待 DOM 更新后生成二维码
        this.$nextTick(() => {
          this.generateQRCode(res.data.qrCodeUrl);
        });
        // 开始轮询检测绑定状态
        this.startCheckStatus();
      }
    },
    // 生成二维码
    generateQRCode(url) {
      // 清空之前的二维码
      const qrcodeContainer = this.$refs.qrcode;
      if (qrcodeContainer) {
        qrcodeContainer.innerHTML = "";
      }

      // 生成新的二维码
      this.qrCodeInstance = new QRCode(qrcodeContainer, {
        text: url,
        width: 280,
        height: 280,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    // 刷新二维码
    async refreshQrCode() {
      // 先停止之前的轮询
      this.stopCheckStatus();

      const [err, res] = await to(api.getBindQrCode());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.codeState = res.data.state;
        this.$message.success("二维码已刷新");

        this.$nextTick(() => {
          this.generateQRCode(res.data.qrCodeUrl);
        });
        // 重新开始轮询
        this.startCheckStatus();
      }
    },
    // 开始轮询检测绑定状态
    startCheckStatus() {
      // 先清除之前的定时器
      this.stopCheckStatus();

      // 立即执行一次检测
      this.checkStatus();

      // 每隔3秒检测一次
      this.checkStatusTimer = setInterval(() => {
        this.checkStatus();
      }, 1000);
    },
    // 停止轮询
    stopCheckStatus() {
      if (this.checkStatusTimer) {
        clearInterval(this.checkStatusTimer);
        this.checkStatusTimer = null;
      }
    },
    async unBind(){
       const [err, res] = await to(api.unBind());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.$message.success("解绑成功");
        this.isBindWx = false;
        this.dropConfig.bindWx.text = "绑定微信";
        this.studentGetProfile();
      }
    },
    async checkStatus(){
       const [err, res] = await to(api.checkStatus({
        state: this.codeState
       }));
      if (err) {
        return Promise.reject(err);
      }
      // 如果绑定成功
      if (res.code === 200) {
           // 停止轮询
           this.stopCheckStatus();
           // 关闭弹框
           this.showQrCodeDialog = false;
           // 显示成功提示
           this.$message.success("微信绑定成功");
           // 更新用户信息
           this.isBindWx = true;
           this.dropConfig.bindWx.text = "解绑微信";
           this.studentGetProfile();
      }
      // 如果二维码过期或失效（code 为 901 或 903），自动刷新二维码
      else if (res.code === 901 || res.code === 903) {
        console.log('二维码已过期，自动刷新...');
        // 自动刷新二维码（不显示成功提示）
        this.autoRefreshQrCode();
      }
    },
    // 自动刷新二维码（静默刷新，不显示提示）
    async autoRefreshQrCode() {
      // 先停止之前的轮询
      this.stopCheckStatus();

      const [err, res] = await to(api.getBindQrCode());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.codeState = res.data.state;

        this.$nextTick(() => {
          this.generateQRCode(res.data.qrCodeUrl);
        });
        // 重新开始轮询
        this.startCheckStatus();
      }
    },
    async studentGetProfile(){
      const [err, res] = await to(api.studentGetProfile());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
         setCookies("userInfo", res.data);
        this.$store.dispatch("setUserInfo",res.data);
        this.haveCheckIn = res.data.haveCheckIn == 1 ? true : false;
        if(this.haveCheckIn){
          this.dropConfig.checkIn.text = "已报到";
        }else{
          this.dropConfig.checkIn.text = "报到";
        }
      }
    },
    async loginOutFn() {
      const [err, res] = await to(api.userLogout());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        setCookies("token", "");
        setCookies("userInfo", "");
        setCookies("onOff", "");
        setCookies("homeWorkParams", "");
        this.$message.success("退出成功");
        setTimeout(() => {
          this.$router.replace({ name: "loginout" });
        }, 1000);
      }
    },
    toHome() {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" });
      }
    },
  },
  computed: {
 currentAuth(){
    return this.$store.state.auth || 'teach';
  },
  authList(){
    return this.$store.state.userInfo.systemAuthList || [];
    // return ['adultTeach','studyOnline','train'];
  },
  studentRollData(){
    return this.$store.state.studentRoll || {};
  },
     pagePath(){
      return this.$route.name;
    },
    isLogin() {
      return this.$store.state.token ? true : false;
    },
    showSearch() {
      // return this.$route.name === "home" ? true : false;
      return false;
    },
    currentPathName() {
      return this.$route.meta.name || "";
    },
    filteredRouterConfig() {
      if (this.studentMenuList === null) return this.routerConfig;
      let result = {};
      for (let key in this.routerConfig) {
        let code = this.menuCodeMap[key];
        if (!code || this.studentMenuList.includes(code)) {
          result[key] = this.routerConfig[key];
        }
      }
      return result;
    },
    filteredDropConfig() {
      const schoolCode = (this.pageConfig && this.pageConfig.schoolCode)
        || (this.$store.state.sysSetting && this.$store.state.sysSetting.schoolCode);
      const hideGraduateRegister = schoolCode == 10599;
      let result = {};
      if (this.studentMenuList === null) {
        for (let key in this.dropConfig) {
          if (hideGraduateRegister && key === 'graduateRegister') continue;
          result[key] = this.dropConfig[key];
        }
        return result;
      }
      for (let key in this.dropConfig) {
        if (hideGraduateRegister && key === 'graduateRegister') continue;
        let code = this.menuCodeMap[key];
        if (!code || this.studentMenuList.includes(code)) {
          result[key] = this.dropConfig[key];
        }
      }
      return result;
    },
    userName() {
      let _name = "";
      let _obj = getCookies("userInfo");
      if(_obj){
      _obj = JSON.parse(_obj);
      _name = _obj.name;
      }
      return _name;
    },
  },
  props: {
    pageConfig: {
      default() {
        return {};
      },
    },
  },
  watch: {
    showQrCodeDialog(newVal) {
      // 当弹框关闭时，停止轮询
      if (!newVal) {
        this.stopCheckStatus();
      }
    }
  },
  components: {
    SearchView,
    // LoginoutBox
  },
};
</script>
<style lang="scss">
@import "@/styles/color.scss";
.headerView {
  .headerView_box {
    height: 70px;
    background: #fff;
    color: #cdd9fc;
    // overflow: hidden;
    .headerView_wrap {
      display: flex;
      justify-content: space-between;
      width: 1400px;
      margin: 0 auto;
      height: 70px;
      .img_item {
        width: 30px;
        height: 30px;
        object-fit: cover;
        border-radius: 10px;
        margin-right: 10px;
      }
      .header_left {
        display: flex;
        align-items: center;
        cursor: pointer;
        .logo {
          width: 30px;
          height: 30px;
        }
        .name {
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-size: 24px;
          color: #333333;
          letter-spacing: 0;
          line-height: 24px;
          font-weight: 700;
        }
      }
      .header_middle {
        height: 70px;
        line-height: 70px;
        .router_item {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #666666;
          line-height: 16px;
          font-weight: 500;
          padding: 0 8px 24px;
          border-bottom: 2px solid transparent;
          &:hover {
            color: $themeColor;
          }
        }
        .router_item + .router_item {
          margin-left: 10px;
        }
        .router-link-active {
          color: $themeColor;
          border-color: $themeColor;
        }
      }
      .header_right_box {
        display: flex;
        align-items: center;
        justify-content: center;
        .right_item {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 18px;
            height: 20px;
            margin-right: 6px;
            object-fit: contain;
          }
          span {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 500;
          }
          &:hover{
            span{
              color: $themeColor;
            }

          }
        }
        .header_logined {
          height: 56px;
          display: flex;
          align-items: center;

          color: #fff;
          cursor: pointer;
          position: relative;
          .login_ava {
            width: 19px;
            height: 19px;
            margin-right: 10px;
          }
          &:hover {
            color: #fff;
            .select_drow {
              display: flex;
            }
          }
          .user_ico {
            font-size: 24px;
            margin-right: 10px;
          }
          .user_name {
            margin-right: 10px;
            font-size: 16px;
            color: #333;
          }
          .select_arrow {
            position: absolute;
            right: 0px;
            top: 20px;
            transform: rotate(0deg);
            color: #333;
            font-size: 18px;
          }

          .select_arrow_1 {
            animation-name: arrow_ani;
            animation-duration: 0.3s;
            animation-timing-function: linear;
            animation-iteration-count: initial;
            animation-fill-mode: forwards;
            /* Safari and Chrome: */
            -webkit-animation-name: arrow_ani;
            -webkit-animation-duration: 0.3s;
            -webkit-animation-timing-function: linear;
            -webkit-animation-iteration-count: initial;
            -webkit-animation-play-state: running;
            animation-fill-mode: forwards;
          }
          @keyframes arrow_ani {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(180deg);
            }
          }

          @-webkit-keyframes arrow_ani /* Safari and Chrome */ {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(180deg);
            }
          }

          .select_arrow_2 {
            animation-name: arrow_ani_1;
            animation-duration: 0.3s;
            animation-timing-function: linear;
            animation-iteration-count: initial;
            animation-fill-mode: forwards;
            /* Safari and Chrome: */
            -webkit-animation-name: arrow_ani_1;
            -webkit-animation-duration: 0.3s;
            -webkit-animation-timing-function: linear;
            -webkit-animation-iteration-count: initial;
            -webkit-animation-play-state: running;
            animation-fill-mode: forwards;
          }
          @keyframes arrow_ani_1 {
            0% {
              transform: rotate(180deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }

          @-webkit-keyframes arrow_ani_1 /* Safari and Chrome */ {
            0% {
              transform: rotate(180deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }
          .select_drow {
            position: absolute;
            top: 48px;
            right: 0px;
            width: 300px;
            display: none;
            flex-wrap: wrap;
            justify-content: flex-start;
            z-index: 9999!important;
            background: #fff;
            box-shadow: 0 5px 10px 10px rgba(0, 0, 0, 0.2);
            padding: 10px;
            border-radius: 5px;
            .drow_item {
              position: relative;
              width: 88px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #333;
              // background: #d6e6f8;
              border-radius: 5px;
              &:hover {
                // background: #BDDAFC;
                // color: $themeColor;
              }
            }
            .login_out_btn{
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #1547EC23;
              color: $themeColor;
              margin-top: 5px;
              border-radius: 5px;
            }
            .active_drop {
              color: $themeColor;
            }
            .checked_item {
              color: #67C23A;
              cursor: default;
              &:hover {
                color: #67C23A;
              }
            }
          }
        }
        .right_active{
          position: relative;
          color: $themeColor;
          &::before{
                display: block;
                content: "";
                height: 2px;
                background: $themeColor;
                width: 70px;
                position: absolute;
                bottom: -25px;
                left: 0px;

          }
        }
        .right_1,
        .right_2
       {
          border-right: 1px solid #d4d4d4;
          padding-right: 10px;
          margin-right: 10px;
          cursor: pointer;
        }
        .right_3 {
          padding-right: 15px;
        }
        .right_4 {
          border-left: 1px solid #d4d4d4;
          padding-left: 25px;
          cursor: pointer;
        }
        .right_2{
          img{
            position: relative;
            top: 1px;
          }
        }
        .right_1{
          position: relative;
           .un_read{
              position: absolute;
              left: 60px;
              top: 0;
              width: 8px;
              height: 8px;
              background: #ff3030;
              border-radius: 100%;
        }

              .drow_num{
                position: absolute;
                top: -10px;
                right: 10px;
                background: red;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 18px;
                height: 18px;
                font-size: 12px;
                border-radius: 100%;
                color: #fff!important;
              }
        }
        .header_right_tip {
          height: 28px;
          line-height: 25px;
          border: 1px solid $themeColor;
          border-radius: 10px;
          text-align: center;
          margin-left: 25px;
          font-size: 12px;
          width: 90px;
          color: $themeColor;
          cursor: pointer;
        }
      }

      .switch_box{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .tab_switch {
        height: 30px;

        display: flex;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        .switch_item {
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          font-size: 14px;
          color: #666;
          cursor: pointer;
          border-radius: 5px;
          transition: all 0.3s ease;

          &:hover {
            color: $themeColor;
          }

          &.active {
            background: $themeColor;
            color: #fff;
          }

          &:not(:last-child) {
            margin-right: 5px;
          }
        }
      }
    }
  }
}

// 微信二维码弹框样式
.wechat-qrcode-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    background: linear-gradient(135deg, #07c160 0%, #00d97e 100%);
  }
}

.qrcode-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  background: linear-gradient(135deg, #07c160 0%, #00d97e 100%);

  .wechat-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;

    .wechat-icon {
      font-size: 48px;
      color: #fff;
      margin-bottom: 12px;
    }

    .wechat-title {
      font-size: 22px;
      color: #fff;
      font-weight: 500;
      letter-spacing: 1px;
    }
  }

  .qrcode-tip {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 25px;
    text-align: center;
  }

  .qrcode-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    margin-bottom: 20px;

    img {
      display: block;
      border-radius: 8px;
    }
  }

  .qrcode-footer {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .btn-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    width: 100%;
  }

  .refresh-btn,
  .close-btn {
    flex: 1;
    max-width: 160px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 22px;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      border-color: rgba(255, 255, 255, 0.8);
    }

    &:active {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .refresh-btn {
    i {
      margin-right: 5px;
      font-size: 16px;
    }
  }
}

// 申请毕业确认弹框样式
.apply-graduation-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, $themeColor 0%, #4169ff 100%);
    padding: 20px;
    text-align: center;

    .el-dialog__title {
      color: #fff;
      font-size: 20px;
      font-weight: 500;
    }

    .el-dialog__headerbtn {
      top: 20px;
      right: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 20px;

        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .el-dialog__body {
    padding: 30px 20px;
  }

  .el-dialog__footer {
    padding: 15px 20px 20px;
    text-align: center;
    border-top: 1px solid #e8e8e8;
  }
}

.apply-dialog-content {
    .m_tip{
      margin-left: 15px;
      font-size: 14px;
      color: #f74949;
    }
  .graduation-form {
    margin-top: 20px;
    .el-form-item {
      margin-bottom: 20px;

      .el-form-item__label {
        color: #333;
        font-weight: 500;
        font-size: 15px;
      }

      .el-form-item__content {
        line-height: 32px;
      }

      .form-value {
        color: #666;
        font-size: 15px;
        display: inline-block;
        padding: 0 10px;
      }
    }
  }
}

.dialog-footer {
  .el-button {
    min-width: 100px;
    padding: 10px 20px;

    &:not(:last-child) {
      margin-right: 15px;
    }
  }
}

// 毕业申请二次确认弹框样式
.graduation-confirm-box {
  z-index: 9999 !important;
}

// 毕业生信息核对弹框样式
.verify-roll-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);

  .el-dialog__header {
    background: linear-gradient(135deg, $themeColor 0%, #4169ff 100%);
    padding: 16px 20px;
    text-align: center;

    .el-dialog__title {
      color: #fff;
      font-size: 17px;
      font-weight: 500;
      letter-spacing: 1px;
    }

    .el-dialog__headerbtn {
      top: 18px;
      right: 18px;
      .el-dialog__close {
        color: #fff;
        font-size: 18px;
        &:hover { color: rgba(255, 255, 255, 0.85); }
      }
    }
  }

  .el-dialog__body {
    padding: 28px 24px 12px;
    margin-top: 20px;
  }

  .el-dialog__footer {
    padding: 12px 24px 18px;
    border-top: 1px solid #f0f0f0;
  }

  .verify-roll-content {
    .info-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .info-item {
      display: flex;
      align-items: center;
      padding: 11px 4px;
      font-size: 14px;
      border-bottom: 1px dashed #ececec;
      &:last-child { border-bottom: none; }
    }
    .info-label {
      width: 84px;
      color: #909399;
      flex-shrink: 0;
    }
    .info-value {
      flex: 1;
      color: #303133;
      font-weight: 500;
      word-break: break-all;
    }
    .verify-tip {
      margin-top: 14px;
      font-size: 13px;
      color: #f56c6c;
      line-height: 1.5;
    }
  }

  .verify-roll-footer {
    display: flex;
    justify-content: center;
    gap: 16px;
    .el-button {
      min-width: 110px;
      padding: 9px 20px;
      border-radius: 6px;
      font-size: 14px;
      & + .el-button { margin-left: 0; }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderView.vue